<app-menu>
<ag-grid-angular *ngIf="gridReady"
style="width: 100%; height: 100%;"
[columnDefs]="columnDefs"
[defaultColDef]="defaultColDef"
[rowModelType]="rowModelType"
[cacheBlockSize]="cacheBlockSize"
[cacheOverflowSize]="cacheOverflowSize"
[maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
[infiniteInitialRowCount]="infiniteInitialRowCount"
[sideBar]="true"
[getRowId]="getRowId"
[rowData]="rowData"
[class]="themeClass"
[initialState]="initialState"
[gridOptions]="gridOptions"
(stateUpdated)="onStateUpdated($event)"
(gridReady)="onGridReady($event)">
</ag-grid-angular>
</app-menu>